import wordmarkAsset from "@/assets/brand/retail-ranker-wordmark.png.asset.json";
import markAsset from "@/assets/brand/retail-ranker-mark.png.asset.json";

type LogoProps = {
  variant?: "wordmark" | "mark";
  className?: string;
  alt?: string;
  eager?: boolean;
};

/**
 * Retail Ranker brand logo.
 * - `wordmark`: full "Retail Ranker" lockup with tagline (use in headers, marketing).
 * - `mark`: standalone compass/storefront mark (use for favicons, avatars, tight spaces).
 */
export function Logo({ variant = "wordmark", className, alt, eager }: LogoProps) {
  const asset = variant === "mark" ? markAsset : wordmarkAsset;
  return (
    <img
      src={asset.url}
      alt={alt ?? (variant === "mark" ? "Retail Ranker" : "Retail Ranker — Retail Market Intelligence Platform")}
      className={className}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
    />
  );
}

export { wordmarkAsset, markAsset };